
export const handleActionError = (errorMessage, e) => {
    let error = {};
    if (e.isAxiosError && e.response){ 
        // Scrub token
        const reqConfig = e.response.config;
        if (reqConfig.data){
            reqConfig.data = JSON.parse(reqConfig.data);
            if (reqConfig.data.token){
                reqConfig.data.token = "[REDACTED]";
            }
        }
        error.config = reqConfig;
    } else {
        error = e;
    }
    console.error(errorMessage, error);
    // TODO configure something like Rollbar to log these types of errors
}